import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  Inject,
} from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as XLSX from "xlsx";
import { MatDialog, MatDialogRef } from "@angular/material";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-create-promotion-rules",
  templateUrl: "./create-promotion-rules.component.html",
  styleUrls: ["./create-promotion-rules.component.scss"],
})
export class CreatePromotionRulesComponent implements OnInit {
  @Output() moveToPreviousPageEvent = new EventEmitter();
  @Output() moveToNextPageEvent = new EventEmitter();
  @Input() incentiveAndPayout: any;
  @Input() possibleValuesList: any;
  @Input() questionList: any;
  @ViewChild("myFileInput") myFileInput: any;
  @ViewChild("myFileInputExcelMerge") myFileInputExcelMerge: any;
  @ViewChild("productFileInput") productFileInput: any;
  @Input() maxPayoutPerClaim: any;
  @Output() maxPayoutPerClaimVal = new EventEmitter();

  createPromoForm!: FormGroup;
  rulesConditionList: any = ["AND", "OR"];
  showMenu: boolean = false;
  menuIndex!: number;
  criterias: any = [];
  criteriaPossibleValuesList: any = [];
  payoutPossibleValuesList: any = [];
  questionRegex = /##[0-9]##/;
  childCriteriasCondition: string = "AND";
  parentCriteriaStructure: any = {
    type: "GROUP",
    logicalConditionBetweenChildCriterias: "AND",
    criteriaPayout: {
      id: null,
      payAgainstType: "",
      payAsType: "",
      criteriaPayoutRanges: [],
      criteriaPayoutProductLevels: [],
      maxPayoutPerPoNumber: null,
      uploadedFileName: null,
      name: [""],
      basePayout: [false],
    },
    criterias: [],
  };
  criteriaPayoutRangesStructure: any = {
    minBookingAmount: "",
    maxBookingAmount: "",
    sortOrder: null,
  };
  criteriasStructure: any = {
    type: "SINGLE",
    questionInfo: {
      questionIdentifier: "TEMPLATED_CRITERIA",
      selectedValues: [],
    },
    field: "",
    shouldBeCondition: "",
    acceptedValues: [],
    uploadedFileName: null,
  };
  dropdownSettings = {};
  fileUploadProductIndex: { reqIndex: number | null } = {
    reqIndex: null,
  };
  seperator = "###";

  downloadExcelPromoRulesModalOpen = false;
  downloadExcelPromoRulesData: any = null;

  constructor(private fb: FormBuilder, private dialog: MatDialog) {}

  ngOnInit() {
    this.intializeForm();
    this.dropdownSettings = {
      singleSelection: false,
      idField: "id",
      textField: "text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 2,
      allowSearchFilter: true,
      maxHeight: 100,
      noDataAvailablePlaceholderText: "Please upload SKU list.",
    };
  }

  intializeForm() {
    this.criterias = this.incentiveAndPayout.criterias;
    this.criteriaPossibleValuesList = this.possibleValuesList.TEMPLATED_CRITERIA;
    this.payoutPossibleValuesList = this.possibleValuesList.TEMPLATED_PAYOUT;
    this.createPromoForm = this.fb.group({
      requirement: this.fb.array(this.createRequirementArray()),
    });
  }

  createRequirementItem(parentCondition?: any): FormGroup {
    return this.fb.group({
      name: [""],
      basePayout: [false],
      ruleRequirement: parentCondition
        ? parentCondition
        : this.incentiveAndPayout.logicalConditionBetweenChildCriterias,
      rule: this.fb.array([this.createRuleArray()]),
      payout: this.fb.array([this.createPayoutArray()]),
    });
  }

  createRequirementArray(): FormGroup[] {
    const arr = [];
    this.childCriteriasCondition =
      this.criterias[0].logicalConditionBetweenChildCriterias;
    for (let i = 0; i < this.criterias.length; i++) {
      arr.push(
        this.createRequirementItemList(
          this.criterias[i].criterias,
          this.criterias[i].criteriaPayout,
          this.criterias[i].logicalConditionBetweenChildCriterias
        )
      );
    }
    return arr;
  }

  createRequirementItemList(criterias: any, criteriaPayouts: any, parentCondition?: any): FormGroup {
    const form = this.fb.group({
      ruleRequirement: this.incentiveAndPayout.logicalConditionBetweenChildCriterias,
      rule: this.fb.array(this.createRuleArrayList(criterias)),
      payout: this.fb.array(this.createPayoutArrayList(criteriaPayouts)),
      name: [criteriaPayouts.name || ""],
      basePayout: [criteriaPayouts.basePayout || false],
    });
    this.updateconditionRecurisvely(form.get("rule") as FormArray, parentCondition);
    return form;
  }

  updateconditionRecurisvely(formArray: FormArray, parentCondition: string) {
    (formArray.controls as FormGroup[]).forEach((group: FormGroup) => {
      const ruleCtrl = group.get("ruleCondition");
      if (ruleCtrl) {
        ruleCtrl.setValue(parentCondition, { emitEvent: false });
      }
      if (group.get("type")!.value === "GROUP") {
        const childCondition = group.get("childCondition")!.value;
        const childArray = group.get("criterias") as FormArray;
        if (childArray) {
          this.updateconditionRecurisvely(childArray, childCondition);
        }
      }
    });
  }

  createRuleArrayList(criterias: any): FormGroup[] {
    const arr = [];
    for (let i = 0; i < criterias.length; i++) {
      arr.push(this.setRuleArray(criterias[i]));
    }
    return arr;
  }

  createPayoutArrayList(criteriaPayouts: any): FormGroup[] {
    const arr = [];
    if (
      criteriaPayouts.criteriaPayoutRanges.length == 0 &&
      criteriaPayouts.criteriaPayoutProductLevels.length == 0
    ) {
      arr.push(this.setPayoutArray(criteriaPayouts, 0));
    } else if (criteriaPayouts.criteriaPayoutRanges.length > 0) {
      for (let i = 0; i < criteriaPayouts.criteriaPayoutRanges.length; i++) {
        arr.push(this.setPayoutArray(criteriaPayouts, i));
      }
    } else {
      arr.push(this.setPayoutProductLevelsArray(criteriaPayouts));
    }
    return arr;
  }

  getRequirenmentList(form: any) {
    return form.controls.requirement.controls;
  }

  getRuleList(form: any) {
    return form.controls.rule.controls;
  }

  getPayoutList(form: any) {
    return form.controls.payout.controls;
  }

  setRuleArray(criterias?: any, parentType?: any, parentCondition?: any): FormGroup {
    if (criterias.type === "GROUP") {
      const groupCondition = parentCondition
        ? parentCondition
        : criterias.logicalConditionBetweenChildCriterias || "AND";
      return this.fb.group({
        type: ["GROUP"],
        ruleCondition: [],
        childCondition: [groupCondition],
        onlyEligibilityEvaluation: [criterias.onlyEligibilityEvaluation || false],
        criterias: this.fb.array(
          (criterias.criterias || []).map((child: any) =>
            this.setRuleArray(
              child,
              "GROUP",
              child.logicalConditionBetweenChildCriterias
            )
          )
        ),
      });
    }

    if (
      criterias.questionInfo.selectedValues &&
      criterias.questionInfo.selectedValues.length
    ) {
      let isExcelMerge = this.criteriaPossibleValuesList[0].possibleValues.some(
        (x: any) => {
          return (
            x.formFieldFormat == "EXCEL_MERGE" &&
            x.value == criterias.questionInfo.selectedValues[1].selectedValue
          );
        }
      );
      if (
        criterias.questionInfo.selectedValues &&
        criterias.questionInfo.selectedValues.length &&
        isExcelMerge
      ) {
        criterias.acceptedValues = criterias.acceptedValues.map((x: any) => {
          return {
            id: x,
            text:
              x.split(this.seperator)[0] +
              " " +
              `(${x.split(this.seperator).slice(1).join(") (")})`,
          };
        });
      }
    }

    return this.fb.group({
      type: criterias.type,
      ruleCondition:
        parentType === "GROUP" ? parentCondition : this.childCriteriasCondition,
      ruleSelection: [
        criterias.questionInfo.selectedValues &&
        criterias.questionInfo.selectedValues.length
          ? criterias.questionInfo.selectedValues[0].selectedValue
          : "",
        [Validators.required],
      ],
      productSelection: [
        criterias.questionInfo.selectedValues &&
        criterias.questionInfo.selectedValues.length
          ? criterias.questionInfo.selectedValues[1].selectedValue
          : "",
        [Validators.required],
      ],
      filterSelection: [
        criterias.questionInfo.selectedValues &&
        criterias.questionInfo.selectedValues.length
          ? criterias.questionInfo.selectedValues[2].selectedValue
          : "",
        [Validators.required],
      ],
      ruleValueSelection: [
        criterias.acceptedValues ? criterias.acceptedValues : null,
        [Validators.required],
      ],
      uploadedFileName: [criterias.uploadedFileName || null],
      onlyEligibilityEvaluation: [criterias.onlyEligibilityEvaluation || false],
    });
  }

  setPayoutArray(criteriaPayout: any, index: any): FormGroup {
    if (index == 0) {
      return this.fb.group({
        payoutType: [
          criteriaPayout.payAgainstType ? criteriaPayout.payAsType : "",
          [Validators.required],
        ],
        payoutRangeType: [
          criteriaPayout.payAsType ? criteriaPayout.payAgainstType : "",
          [Validators.required],
        ],
        payoutAmtRangeMin: [
          criteriaPayout.criteriaPayoutRanges.length &&
          criteriaPayout.criteriaPayoutRanges[index].minBookingAmount >= 0
            ? criteriaPayout.criteriaPayoutRanges[index].minBookingAmount
            : "",
          [Validators.required],
        ],
        payoutAmtRangeMax: [
          criteriaPayout.criteriaPayoutRanges.length &&
          criteriaPayout.criteriaPayoutRanges[index].maxBookingAmount >= 0
            ? criteriaPayout.criteriaPayoutRanges[index].maxBookingAmount
            : "",
        ],
        percentageOrPointPayout: [
          criteriaPayout.payAsType == "PERCENTAGE"
            ? (criteriaPayout.criteriaPayoutRanges.length &&
                criteriaPayout.criteriaPayoutRanges[index].percentagePayout) ||
              null
            : (criteriaPayout.criteriaPayoutRanges.length &&
                criteriaPayout.criteriaPayoutRanges[index].pointsPayout) ||
              null,
          [Validators.required],
        ],
        maxPayoutPerPoNumber: [
          criteriaPayout.maxPayoutPerPoNumber
            ? criteriaPayout.maxPayoutPerPoNumber
            : null,
        ],
        name: [criteriaPayout.name ? criteriaPayout.name : ""],
        basePayout: [criteriaPayout.basePayout ? criteriaPayout.basePayout : false],
        uploadedFileName: [criteriaPayout.uploadedFileName || null],
      });
    } else {
      return this.fb.group({
        payoutAmtRangeMin: [
          criteriaPayout.criteriaPayoutRanges[index].minBookingAmount >= 0
            ? criteriaPayout.criteriaPayoutRanges[index].minBookingAmount
            : "",
          [Validators.required],
        ],
        payoutAmtRangeMax: [
          criteriaPayout.criteriaPayoutRanges[index].maxBookingAmount >= 0
            ? criteriaPayout.criteriaPayoutRanges[index].maxBookingAmount
            : "",
        ],
        percentageOrPointPayout: [
          criteriaPayout.payAsType == "PERCENTAGE"
            ? criteriaPayout.criteriaPayoutRanges[index].percentagePayout || null
            : criteriaPayout.criteriaPayoutRanges[index].pointsPayout || null,
          [Validators.required],
        ],
        maxPayoutPerPoNumber: [
          criteriaPayout.maxPayoutPerPoNumber
            ? criteriaPayout.maxPayoutPerPoNumber
            : null,
        ],
        name: [criteriaPayout.name ? criteriaPayout.name : ""],
        basePayout: [criteriaPayout.basePayout ? criteriaPayout.basePayout : false],
        uploadedFileName: [criteriaPayout.uploadedFileName || null],
      });
    }
  }

  setPayoutProductLevelsArray(criteriaPayout: any): FormGroup {
    return this.fb.group({
      payoutType: [
        criteriaPayout.payAgainstType ? criteriaPayout.payAsType : "",
        [Validators.required],
      ],
      payoutRangeType: [
        criteriaPayout.payAsType ? criteriaPayout.payAgainstType : "",
        [Validators.required],
      ],
      payoutAmtRangeMin: [
        criteriaPayout.criteriaPayoutProductLevels,
        [Validators.required],
      ],
      payoutAmtRangeMax: [criteriaPayout.criteriaPayoutProductLevels],
      percentageOrPointPayout: [
        criteriaPayout.criteriaPayoutProductLevels,
        [Validators.required],
      ],
      maxPayoutPerPoNumber: [
        criteriaPayout.maxPayoutPerPoNumber
          ? criteriaPayout.maxPayoutPerPoNumber
          : null,
      ],
      uploadedFileName: [criteriaPayout.uploadedFileName || null],
    });
  }

  createRuleArray(parentCondition?: any): FormGroup {
    return this.fb.group({
      type: ["SINGLE"],
      ruleCondition: [
        parentCondition ? parentCondition : this.childCriteriasCondition,
        [Validators.required],
      ],
      ruleSelection: ["", [Validators.required]],
      productSelection: ["", [Validators.required]],
      filterSelection: ["", [Validators.required]],
      ruleValueSelection: [null, [Validators.required]],
      uploadedFileName: [null],
      onlyEligibilityEvaluation: [false],
    });
  }

  createGroupRule(criteria?: any, childCondition?: any): FormGroup {
    return this.fb.group({
      type: ["GROUP"],
      ruleCondition: [
        criteria && criteria.logicalConditionBetweenChildCriterias
          ? criteria.logicalConditionBetweenChildCriterias
          : this.childCriteriasCondition,
      ],
      childCondition: [
        criteria && criteria.logicalConditionBetweenChildCriterias
          ? criteria.logicalConditionBetweenChildCriterias
          : "AND",
      ],
      onlyEligibilityEvaluation: [criteria && criteria.onlyEligibilityEvaluation ? criteria.onlyEligibilityEvaluation : false],
      criterias: this.fb.array(
        (criteria.criterias || []).map((child: any) =>
          child.type === "GROUP"
            ? this.createGroupRule(child)
            : this.setRuleArray(
                child,
                "GROUP",
                criteria.logicalConditionBetweenChildCriterias
              )
        )
      ),
    });
  }

  createPayoutArray() {
    return this.fb.group({
      payoutType: ["", [Validators.required]],
      payoutRangeType: ["", [Validators.required]],
      payoutAmtRangeMin: ["", [Validators.required]],
      payoutAmtRangeMax: [""],
      percentageOrPointPayout: [null, [Validators.required]],
      maxPayoutPerPoNumber: [null],
      name: [""],
      basePayout: [false],
      uploadedFileName: [null],
    });
  }

  createPayoutRangeArray() {
    return this.fb.group({
      payoutAmtRangeMin: ["", [Validators.required]],
      payoutAmtRangeMax: [""],
      percentageOrPointPayout: [null, [Validators.required]],
      maxPayoutPerPoNumber: [null],
    });
  }

  addRequirement() {
    const control = <FormArray>this.createPromoForm.get("requirement");
    let parentCondition = control.at(0).get("ruleRequirement")!.value;
    control.push(this.createRequirementItem(parentCondition));
  }

  removeRequirement(i: any) {
    const control = <FormArray>this.createPromoForm.get("requirement");
    control.removeAt(i);
    this.showMenu = false;
  }

  addRule(i: any) {
    const control = (this.createPromoForm.get("requirement") as any)
      ["controls"][i]
      .get("rule") as FormArray;
    let parentCondition = "";
    if (control.length > 0) {
      parentCondition = control.at(0).get("ruleCondition")!.value;
    }
    control.push(this.createRuleArray(parentCondition));
  }

  addGroupAtRequirementLevel(reqIndex: number) {
    const ruleArray = (this.createPromoForm.get("requirement") as any)
      ["controls"][reqIndex]
      .get("rule") as FormArray;

    const newGroup = {
      type: "GROUP",
      ruleCondition: "AND",
      criterias: [],
    };
    ruleArray.push(this.createGroupRule(newGroup));
  }

  addRuleInsideGroup(group: FormGroup) {
    const groupArray = group.get("criterias") as FormArray;
    let parentCondition = "";
    if (groupArray.length > 0) {
      parentCondition = groupArray.at(0).get("ruleCondition")!.value;
    }
    groupArray.push(this.createRuleArray(parentCondition));
  }

  addGroupInsideGroupRecursive(group: FormGroup) {
    const groupArray = group.get("criterias") as FormArray;
    const newGroup = {
      type: "GROUP",
      logicalConditionBetweenChildCriterias: "AND",
      criterias: [],
    };
    const newGroupFG = this.createGroupRule(newGroup);
    (newGroupFG.get("criterias") as FormArray).push(this.createRuleArray());
    groupArray.push(newGroupFG);
  }

  removePayoutRule(i: any, k: any) {
    const control = <FormArray>(
      (this.createPromoForm.get("requirement") as any)["controls"][i].get("payout")
    );
    control.removeAt(k);
  }

  addPayoutRule(i: any) {
    const control = <FormArray>(
      (this.createPromoForm.get("requirement") as any)["controls"][i].get("payout")
    );
    control.push(this.createPayoutRangeArray());
  }

  openMenu(index: any) {
    if (this.menuIndex !== index) {
      this.showMenu = true;
      this.menuIndex = index;
      return;
    }
    this.showMenu = !this.showMenu;
    this.menuIndex = index;
  }

  moveToNextPage() {
    const updatedData = this.buildBackendStructure();
    this.incentiveAndPayout = updatedData;
    this.moveToNextPageEvent.emit(updatedData);
  }

  moveToPreviousPage() {
    const updatedData = this.buildBackendStructure();
    this.incentiveAndPayout = updatedData;
    this.moveToPreviousPageEvent.emit(updatedData);
  }

  buildBackendStructure() {
    const formValue = this.createPromoForm.value;

    const backendCriterias = formValue.requirement.map((req: any, reqIndex: any) => {
      return {
        type: "GROUP",
        logicalConditionBetweenChildCriterias:
          req.rule[0].ruleCondition || "AND",
        criterias: this.buildCriteriaRecursive(req.rule),
        criteriaPayout: this.convertFormPayoutToBackend(req.payout, reqIndex),
      };
    });

    if (backendCriterias.length > 0) {
      this.incentiveAndPayout.logicalConditionBetweenChildCriterias =
        formValue.requirement[0].ruleRequirement;
    }

    return {
      ...this.incentiveAndPayout,
      criterias: backendCriterias,
    };
  }

  buildCriteriaRecursive(rules: any[]): any[] {
    return rules.map((rule: any) => {
      if (rule.type === "GROUP") {
        return {
          type: "GROUP",
          logicalConditionBetweenChildCriterias: rule.childCondition,
          onlyEligibilityEvaluation: rule.onlyEligibilityEvaluation || false,
          criterias: this.buildCriteriaRecursive(rule.criterias || []),
        };
      }
      return this.convertFormRuleToCriteria(rule);
    });
  }

  createPayoutStructure() {
    let dataToSend: any[] = [];
    this.createPromoForm.value.requirement.forEach((req: any, reqIndex: any) => {
      let parentCriteria = JSON.parse(
        JSON.stringify(this.parentCriteriaStructure)
      );
      let isExcelMerge = false;
      parentCriteria.logicalConditionBetweenChildCriterias =
        req.rule[0].ruleCondition;

      req.rule.forEach((rule: any, ruleIndex: any) => {
        let criteria = JSON.parse(JSON.stringify(this.criteriasStructure));
        criteria.questionInfo.selectedValues = [
          { selectedValue: rule.ruleSelection, sortOrder: 1 },
          { selectedValue: rule.productSelection, sortOrder: 2 },
          { selectedValue: rule.filterSelection, sortOrder: 3 },
        ];
        criteria.field = rule.productSelection;
        isExcelMerge = this.criteriaPossibleValuesList[0].possibleValues.some(
          (x: any) => {
            return (
              x.formFieldFormat == "EXCEL_MERGE" &&
              x.value == rule.productSelection
            );
          }
        );
        criteria.shouldBeCondition = rule.filterSelection;
        criteria.uploadedFileName =
          this.incentiveAndPayout.criterias[reqIndex].criterias[
            ruleIndex
          ].uploadedFileName;
        if (isExcelMerge) {
          rule.ruleValueSelection != null &&
          typeof rule.ruleValueSelection == "object"
            ? (criteria.acceptedValues = rule.ruleValueSelection.map(
                (x: any) => x.id
              ))
            : (criteria.acceptedValues = []);
        } else {
          rule.ruleValueSelection != null &&
          typeof rule.ruleValueSelection == "object"
            ? (criteria.acceptedValues = rule.ruleValueSelection)
            : !rule.ruleValueSelection
            ? (rule.acceptedValues = [])
            : criteria.acceptedValues.push(rule.ruleValueSelection);
        }
        parentCriteria.criterias.push(criteria);
      });

      req.payout.forEach((payout: any, index: any) => {
        let payoutType = req.payout[0].payoutType;
        if (index == 0) {
          parentCriteria.criteriaPayout.payAsType = payout.payoutType;
          parentCriteria.criteriaPayout.payAgainstType = payout.payoutRangeType;
          parentCriteria.criteriaPayout.maxPayoutPerPoNumber =
            req.payout[req.payout.length - 1].maxPayoutPerPoNumber;
          parentCriteria.criteriaPayout.name = payout.name;
          parentCriteria.criteriaPayout.basePayout = payout.basePayout;
          let criteriaPayout = JSON.parse(
            JSON.stringify(this.criteriaPayoutRangesStructure)
          );
          if (payout.payoutRangeType == "PAY_AGAINST_PRODUCTS") {
            parentCriteria.criteriaPayout.criteriaPayoutProductLevels =
              payout.payoutAmtRangeMin;
            parentCriteria.criteriaPayout.uploadedFileName =
              this.incentiveAndPayout.criterias[
                reqIndex
              ].criteriaPayout.uploadedFileName;
          } else {
            criteriaPayout.minBookingAmount = payout.payoutAmtRangeMin;
            criteriaPayout.maxBookingAmount = payout.payoutAmtRangeMax;
            criteriaPayout.sortOrder = index + 1;
            payoutType == "POINTS"
              ? (criteriaPayout.pointsPayout = payout.percentageOrPointPayout)
              : (criteriaPayout.percentagePayout =
                  payout.percentageOrPointPayout);
            parentCriteria.criteriaPayout.criteriaPayoutRanges.push(
              criteriaPayout
            );
          }
        } else {
          let criteriaPayout = JSON.parse(
            JSON.stringify(this.criteriaPayoutRangesStructure)
          );
          criteriaPayout.minBookingAmount = payout.payoutAmtRangeMin;
          criteriaPayout.maxBookingAmount = payout.payoutAmtRangeMax;
          criteriaPayout.sortOrder = index + 1;
          payoutType == "POINTS"
            ? (criteriaPayout.pointsPayout = payout.percentageOrPointPayout)
            : (criteriaPayout.percentagePayout =
                payout.percentageOrPointPayout);
          parentCriteria.criteriaPayout.criteriaPayoutRanges.push(
            criteriaPayout
          );
        }
      });

      dataToSend.push(parentCriteria);
    });
    this.incentiveAndPayout.criterias = dataToSend;
    this.criterias = dataToSend;
    this.setMaxPayoutData();
  }

  setMaxPayoutData() {
    this.maxPayoutPerClaimVal.emit(this.maxPayoutPerClaim);
  }

  setConditionForAllRules(event: any) {
    this.createPromoForm.value.requirement.forEach((req: any, index: any) => {
      (this.createPromoForm.get("requirement") as any)
        ["controls"][index]
        .controls.ruleRequirement.setValue(event.target.value);
    });
  }

  setGroupCondition(event: any, group: FormGroup) {
    const value = event.target.value;
    group.get("childCondition")!.setValue(value);
  }

  setChildCondition(event: any, childArray: FormArray, reqIndex?: number) {
    const value = event.target.value;
    this.childCriteriasCondition = value;

    const parentGroup = childArray.parent as FormGroup;
    if (parentGroup && parentGroup.get("childCondition")) {
      parentGroup.get("childCondition")!.patchValue(value);
    }
    (childArray.controls as FormGroup[]).forEach((control: FormGroup) => {
      if (control.get("ruleCondition")) {
        control.get("ruleCondition")!.patchValue(value);
      }
    });
  }

  getPayoutSelectionList(ruleItem: FormGroup, type: string) {
    if (!this.payoutPossibleValuesList.length) return;
    const payoutSelectionList: any = {
      productList: null,
    };
    const selectedRule = ruleItem.get("payoutType")!.value;
    if (!selectedRule) return;
    const selectedPayoutIndex = this.payoutPossibleValuesList.findIndex(
      (x: any) => x.value === selectedRule
    );
    if (selectedPayoutIndex === -1) return;
    payoutSelectionList.productList =
      this.payoutPossibleValuesList[selectedPayoutIndex].possibleValues;

    return payoutSelectionList[type];
  }

  getPayoutType(index: any) {
    let payOutType =
      (this.createPromoForm.get("requirement") as any)["controls"][index].controls.payout
        .controls[0].controls.payoutType.value;
    if (payOutType == "PERCENTAGE") {
      return true;
    } else {
      return false;
    }
  }

  setPayoutAmtRangeType(index: any) {
    let payRangeType =
      (this.createPromoForm.get("requirement") as any)["controls"][index].controls.payout
        .controls[0].controls.payoutRangeType.value;
    if (payRangeType == "PAY_AGAINST_PRODUCTS") {
      (this.createPromoForm.get("requirement") as any)
        ["controls"][index].controls.payout.controls[0].controls.payoutAmtRangeMin.setValue([]);
      (this.createPromoForm.get("requirement") as any)
        ["controls"][index].controls.payout.controls[0].controls.payoutAmtRangeMax.setValue([]);
      (this.createPromoForm.get("requirement") as any)
        ["controls"][index].controls.payout.controls[0].controls.percentageOrPointPayout.setValue([]);
      (this.createPromoForm.get("requirement") as any)
        ["controls"][index].controls.payout.controls[0].controls.maxPayoutPerPoNumber.setValue(null);
    } else {
      if (
        typeof (this.createPromoForm.get("requirement") as any)["controls"][index]
          .controls.payout.controls[0].controls.payoutAmtRangeMin.value ==
        "object"
      ) {
        (this.createPromoForm.get("requirement") as any)
          ["controls"][index].controls.payout.controls[0].controls.payoutAmtRangeMin.setValue("");
        (this.createPromoForm.get("requirement") as any)
          ["controls"][index].controls.payout.controls[0].controls.payoutAmtRangeMax.setValue("");
        (this.createPromoForm.get("requirement") as any)
          ["controls"][index].controls.payout.controls[0].controls.percentageOrPointPayout.setValue("");
        (this.createPromoForm.get("requirement") as any)
          ["controls"][index].controls.payout.controls[0].controls.maxPayoutPerPoNumber.setValue(null);
      }
    }
  }

  getPayoutRangeType(index: any) {
    let payRangeType =
      (this.createPromoForm.get("requirement") as any)["controls"][index].controls.payout
        .controls[0].controls.payoutRangeType.value;
    if (payRangeType == "PAY_AGAINST_PRODUCTS") {
      const control = <FormArray>(
        (this.createPromoForm.get("requirement") as any)["controls"][index].get("payout")
      );
      for (let i = 1; i < control.controls.length; i++) {
        control.removeAt(i);
      }
      return "showUploadLayout";
    } else {
      return "showDefaultLayout";
    }
  }

  uploadProductList(i: number, productLevelFileInput: HTMLInputElement) {
    this.fileUploadProductIndex.reqIndex = i;
    productLevelFileInput.click();
  }

  getProductFile(event: any, ruleItem: FormGroup, productLevelFileInput: HTMLInputElement) {
    let data;
    const target = event.target as HTMLInputElement;
    if (!target.files || target.files.length !== 1) {
      throw new Error("Cannot use multiple files");
    }
    const file = target.files[0];
    const reader: FileReader = new FileReader();

    reader.readAsBinaryString(file);
    reader.onload = (e: any) => {
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: "binary" });

      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      data = XLSX.utils.sheet_to_json(ws);

      this.setDataInFormFields(data);
      ruleItem.patchValue({ uploadedFileName: file.name });
      productLevelFileInput.value = "";
    };
  }

  setDataInFormFields(data: any) {
    let columnsList = Object.keys(data[0]);
    let productList: any[] = [];
    data.forEach((val: any) => {
      productList.push({
        productIdentifier: val[columnsList[0]].toString(),
        type: val[columnsList[1]].toString(),
        percentagePayout: val[columnsList[2]].toString(),
      });
    });
    (this.createPromoForm.get("requirement") as any)
      ["controls"][this.fileUploadProductIndex.reqIndex!].controls.payout.controls[0].controls.payoutAmtRangeMin.setValue(productList);
    (this.createPromoForm.get("requirement") as any)
      ["controls"][this.fileUploadProductIndex.reqIndex!].controls.payout.controls[0].controls.payoutAmtRangeMax.setValue(productList);
    (this.createPromoForm.get("requirement") as any)
      ["controls"][this.fileUploadProductIndex.reqIndex!].controls.payout.controls[0].controls.percentageOrPointPayout.setValue(productList);
  }

  openProductDialogContent(i: any) {
    this.dialog.open(ProductListDialog, {
      width: "514px",
      data: (this.createPromoForm.get("requirement") as any)["controls"][i].controls
        .payout.controls[0].controls.payoutAmtRangeMin.value,
    });
  }

  showDownloadExcelFormatDialog(
    ruleItem: FormGroup,
    listType: string
  ) {
    const dropdownData = this.getPayoutSelectionList(ruleItem, listType);
    const selectedVal = ruleItem.get("payoutRangeType")!.value;

    if (!dropdownData || !selectedVal) return;

    const selectedDropdownData = dropdownData.find(
      (x: any) => x.value === selectedVal
    );
    if (!selectedDropdownData) return;

    const dialogRef = this.dialog.open(DownloadFileFormatPromoRulesDialog, {
      width: "514px",
      data: selectedDropdownData,
    });
    dialogRef.afterClosed().subscribe(() => {});
  }

  closeDownloadExcelPromoRulesModal(): void {
    this.downloadExcelPromoRulesModalOpen = false;
    this.downloadExcelPromoRulesData = null;
  }

  downloadExcelPromoRules(): void {
    if (!this.downloadExcelPromoRulesData) { return; }
    let columnData: string[][] = [];
    if (this.downloadExcelPromoRulesData.formFieldFormat === "EXCEL") {
      columnData = [["PRODUCT"]];
    } else if (this.downloadExcelPromoRulesData.formFieldFormat === "EXCEL_MERGE") {
      columnData = [["PRODUCT", "TYPE"]];
    } else if (
      this.downloadExcelPromoRulesData.formFieldFormat === "TEXT" &&
      this.downloadExcelPromoRulesData.value === "PAY_AGAINST_PRODUCTS"
    ) {
      columnData = [["PRODUCT", "TYPE", "PAYOUT"]];
    }
    let workbook = XLSX.utils.book_new(),
      worksheet = XLSX.utils.aoa_to_sheet(columnData);
    workbook.SheetNames.push("First");
    workbook.Sheets["First"] = worksheet;
    let xlsbin = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    let buffer = new ArrayBuffer(xlsbin.length),
      array = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array[i] = xlsbin.charCodeAt(i) & 0xff;
    }
    let xlsblob = new Blob([buffer], { type: "application/octet-stream" });
    let url = window.URL.createObjectURL(xlsblob),
      anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = this.downloadExcelPromoRulesData.label.toUpperCase() + ".xlsx";
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  toNumber(val: any) {
    return Number(val);
  }

  private convertFormRuleToCriteria(formRule: any): any {
    if (formRule.type === "GROUP") {
      return {
        type: "GROUP",
        logicalConditionBetweenChildCriterias: formRule.childCondition,
        criterias: (formRule.criterias || []).map((child: any) =>
          this.convertFormRuleToCriteria(child)
        ),
      };
    }

    const criteria = {
      type: "SINGLE",
      questionInfo: {
        questionIdentifier: "TEMPLATED_CRITERIA",
        selectedValues: [
          { selectedValue: formRule.ruleSelection, sortOrder: 1 },
          { selectedValue: formRule.productSelection, sortOrder: 2 },
          { selectedValue: formRule.filterSelection, sortOrder: 3 },
        ],
      },
      field: formRule.productSelection,
      shouldBeCondition: formRule.filterSelection,
      acceptedValues: [],
      uploadedFileName: formRule.uploadedFileName || null,
      onlyEligibilityEvaluation: formRule.onlyEligibilityEvaluation || false,
    };

    const isExcelMerge = this.criteriaPossibleValuesList[0].possibleValues.some(
      (x: any) =>
        x.formFieldFormat === "EXCEL_MERGE" &&
        x.value === formRule.productSelection
    );
    const isExcel = this.criteriaPossibleValuesList[0].possibleValues.some(
      (x: any) =>
        x.formFieldFormat === "EXCEL" && x.value === formRule.productSelection
    );

    if (isExcelMerge) {
      if (
        formRule.ruleValueSelection &&
        typeof formRule.ruleValueSelection === "object"
      ) {
        criteria.acceptedValues = formRule.ruleValueSelection.map((x: any) => x.id);
      } else {
        criteria.acceptedValues = [];
      }
    } else if (isExcel) {
      if (
        formRule.ruleValueSelection &&
        typeof formRule.ruleValueSelection === "object"
      ) {
        criteria.acceptedValues = formRule.ruleValueSelection;
      } else {
        criteria.acceptedValues = [];
      }
    } else {
      if (formRule.ruleValueSelection != null) {
        criteria.acceptedValues = Array.isArray(formRule.ruleValueSelection)
          ? formRule.ruleValueSelection
          : [formRule.ruleValueSelection];
      } else {
        criteria.acceptedValues = [];
      }
    }

    return criteria;
  }

  createDuplicateRuleArray(index: number): FormGroup[] {
    const ruleArray = (this.createPromoForm.get("requirement") as any)
      ["controls"][index]
      .get("rule") as FormArray;

    const arr: FormGroup[] = [];

    ruleArray.controls.forEach((ruleFG: any) => {
      const formRuleValue = ruleFG.value;
      const backendCriteria = this.convertFormRuleToCriteria(formRuleValue);

      if (backendCriteria.type === "GROUP" && formRuleValue.type === "GROUP") {
        arr.push(this.createGroupRule(backendCriteria, formRuleValue.childCondition));
      } else {
        arr.push(
          this.setRuleArray(backendCriteria, "GROUP", formRuleValue.ruleCondition)
        );
      }
    });

    return arr;
  }

  convertFormPayoutToBackend(payoutFormArray: any[], reqIndex: number) {
    const first = payoutFormArray[0];
    const existingCriteria =
      this.incentiveAndPayout.criterias &&
      this.incentiveAndPayout.criterias[reqIndex];
    const backend = {
      id:
        existingCriteria && existingCriteria.criteriaPayout
          ? existingCriteria.criteriaPayout.id || null
          : null,
      name: first.name || "",
      basePayout: first.basePayout || false,
      payAsType: first.payoutType || "",
      payAgainstType: first.payoutRangeType || "",
      maxPayoutPerPoNumber:
        payoutFormArray[payoutFormArray.length - 1].maxPayoutPerPoNumber || null,
      criteriaPayoutRanges: [] as any[],
      criteriaPayoutProductLevels: [] as any,
      uploadedFileName: null as any,
    };

    if (first.payoutRangeType === "PAY_AGAINST_PRODUCTS") {
      backend.criteriaPayoutProductLevels = first.payoutAmtRangeMin || [];
      backend.uploadedFileName = first.uploadedFileName;
      return backend;
    }

    payoutFormArray.forEach((row: any, i: any) => {
      backend.criteriaPayoutRanges.push({
        minBookingAmount: row.payoutAmtRangeMin,
        maxBookingAmount: row.payoutAmtRangeMax,
        sortOrder: i + 1,
        ...(first.payoutType === "POINTS"
          ? { pointsPayout: row.percentageOrPointPayout }
          : { percentagePayout: row.percentageOrPointPayout }),
      });
    });

    return backend;
  }

  createDuplicatePayoutArray(index: number): FormGroup[] {
    const payoutControls = (this.createPromoForm.get("requirement") as any)
      ["controls"][index]
      .get("payout") as FormArray;

    const payoutRows = payoutControls.value;
    const backend = this.convertFormPayoutToBackend(payoutRows, index);
    const arr: FormGroup[] = [];

    if (backend.criteriaPayoutProductLevels.length > 0) {
      arr.push(this.setPayoutProductLevelsArray(backend));
    } else {
      backend.criteriaPayoutRanges.forEach((range: any, i: any) => {
        arr.push(this.setPayoutArray(backend, i));
      });
    }

    return arr;
  }

  createRequirementDuplicateItem(index: number): FormGroup {
    const reqForm = (this.createPromoForm.get("requirement") as any)["controls"][index];
    const ruleArray = reqForm.get("rule") as FormArray;
    const parentCondition = ruleArray.at(0).get("ruleCondition")!.value;

    const form = this.fb.group({
      ruleRequirement: reqForm.get("ruleRequirement")!.value,
      rule: this.fb.array(this.createDuplicateRuleArray(index)),
      payout: this.fb.array(this.createDuplicatePayoutArray(index)),
      name: [reqForm.get("name")!.value],
      basePayout: [reqForm.get("basePayout")!.value],
    });
    this.updateconditionRecurisvely(
      form.get("rule") as FormArray,
      parentCondition
    );
    return form;
  }

  duplicateRequirement(index: any) {
    const control = this.createPromoForm.get("requirement") as FormArray;
    control.push(this.createRequirementDuplicateItem(index));
  }

  ngOnDestroy() {
    // this.createPayoutStructure();
  }
}

@Component({
  selector: "product-list-dialog",
  templateUrl: "./product-list-dialog.html",
  styleUrls: ["./product-list-dialog.scss"],
})
export class ProductListDialog {
  constructor(
    public dialogRef: MatDialogRef<ProductListDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}

@Component({
  selector: "download-file-format-dialog",
  templateUrl: "./download-file-format-dialog.html",
  styleUrls: ["./download-file-format-dialog.scss"],
})
export class DownloadFileFormatPromoRulesDialog {
  constructor(
    public dialogRef: MatDialogRef<DownloadFileFormatPromoRulesDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  downloadExcel() {
    let columnData: any[] = [];
    if (this.data.formFieldFormat === "EXCEL") {
      columnData = [["PRODUCT"]];
    } else if (this.data.formFieldFormat === "EXCEL_MERGE") {
      columnData = [["PRODUCT", "TYPE"]];
    } else if (
      this.data.formFieldFormat === "TEXT" &&
      this.data.value === "PAY_AGAINST_PRODUCTS"
    ) {
      columnData = [["PRODUCT", "TYPE", "PAYOUT"]];
    }
    let workbook = XLSX.utils.book_new(),
      worksheet = XLSX.utils.aoa_to_sheet(columnData);
    workbook.SheetNames.push("First");
    workbook.Sheets["First"] = worksheet;
    let xlsbin = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    let buffer = new ArrayBuffer(xlsbin.length),
      array = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array[i] = xlsbin.charCodeAt(i) & 0xff;
    }
    let xlsblob = new Blob([buffer], { type: "application/octet-stream" });
    let url = window.URL.createObjectURL(xlsblob),
      anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = this.data.label.toUpperCase() + ".xlsx";
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}